import { normalQueryTypes } from '@ow/utils'

export const filterSpec = {
  queryTypes: ['equal', 'equalBool', 'isNullBool', 'notNullBool']
    .map((p) => normalQueryTypes[p])
    .filter((v) => v),
}
